import React from 'react';
import { Avatar, AvatarBadge } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { Color } from 'src/theme/color';

export const AvatarVerify = ({ avatar, name, isVerified, isCompact, ...props }: any) => {
	return (
		<Avatar
			w={isCompact ? '70px' : '74px'}
			h={isCompact ? '70px' : '74px'}
			borderRadius="5px"
			src={avatar}
			name={name}
			{...props}
		>
			{isVerified && (
				<AvatarBadge
					right={isCompact ? '1em' : '.5em'}
					boxSize="16px"
					border="none"
					bg={Color.ACTION}
					top="-.6em"
				>
					<CheckIcon
						fontSize="8px"
						fontWeight="bold"
						color="white"
					/>
				</AvatarBadge>
			)}
		</Avatar>
	);
};
